// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3ROLB","text":"SelectPayment_text__35eFZ","title":"SelectPayment_title__2gJaq","btn":"SelectPayment_btn__2Rph1"};